<template>
  <div class="wrapper">
    <FORM  ref="childForm"  @formclick="formclick" :formData="formData"></FORM>
    <table-page ref="childTable"  @checkbox="checkbox" @btnclick="bthClick" :pageData="pageData"></table-page>
  </div>
</template>

<script>
  //table封装组件
  import tablePage from '@/components/page/table.vue'
  import FORM from '@/components/page/form.vue'
  import UPDATE from '@/components/page/update.vue'
  import URL from '@/views/crs36/util/url'
  import DateUtil from '@/utils/IM/tradeDataUtil.js'
  let typeList={"1":"开通账户","2":"真实账户_后台开户","3":"真实账户_前端开户","4":"真实账户_资料上传","5":"真实账户_资料上传_审核成功","6":"真实账户_资料上传_审核失败","7":"真实账户_激活账户","8":"真实账户_存款成功","9":"真实账户_支付失败","10":"真实账户_重新支付成功","11":"真实账户_重新支付失败","12":"真实账户_交易","13":"真实账户_强制平仓","14":"真实账户_保证金不足","15":"真实账户_提交取款","16":"真实账户_取款审批拒绝","17":"真实账户_取款审批成功","18":"模拟账户_后台开户","19":"模拟账户_前端开户","20":"模拟账户_资料上传","21":"模拟账户_资料上传_审核成功","22":"模拟账户_资料上传_审核失败","23":"模拟账户_激活账户","24":"模拟账户_存款","25":"模拟账户_重新支付失败","26":"模拟账户_重新支付成功","27":"模拟账户_支付失败","28":"模拟账户_交易","29":"模拟账户_紧急平仓","30":"模拟账户_保证金不足","31":"模拟账户_取款","32":"模拟账户_提交取款"};//消息类型列表
  import Qs from 'qs'
  import axios from 'axios'
  export default {
    name: 'list',
    components: {
      tablePage,
      FORM,
      UPDATE
    },
    methods: {
      checkbox(row){
        this.deleteIds = row.map(key => key.id).join(",");
      },
      /*表格按钮点击事件*/
      bthClick (clickName, row) {
        if (clickName == "update"){
          this.$refs.childUpdate.open(row);
        }
      },
      /*查询表单按钮点击事件*/
      formclick(clickName, data){
        if("查询" == clickName){
          this.queryData = data;
          this.$refs.childTable.defaultQueryData(data);
        }
      },
    },
    data () {
      return {
        deleteIds:"",
        queryData:{},
        /*新增或更新*/
        updateData:{
          cols:[

                      ]
        },
        /*from查询表单*/
        formData:{
          hasLable: true,
          cols:[
                          { title: 'id', field: 'tempMsgId',hidden:true,data:this.$route.query.tempMsgId},
                          { title: '模板名称', field: 'tempMsgName'},
                          { title: '真实账号', field: 'account'},
                          { title: '消息类型', field: 'type',type:2,optionList:typeList},
                          { title: '状态', field: 'status',type:2,optionList: {"1":"成功","2":"失败"}},
                          { title: '发送时间', field: 'sendTime',type:6},
                          {click:"查询"}
          ]
        },
        /*table生成*/
        pageData: {
          queryUrl: URL.templateRecord.query, //请求路径和参数
          selection: true,
          sequence: true,
          cols: [
                          { title: '消息id', field: 'msgId'},
                          { title: '消息内容', field: 'content'},
                          { title: '模板名称', field: 'tempMsgName'},
                          { title: '消息类型', field: 'type',render:(data)=>{
                              return typeList[data];
                              }},
                          { title: '真实账号', field: 'account'},
                          { title: '状态', field: 'status',render:(data)=>{
                                 return data ==1 ? "成功":"失败";
                          }},
                          { title: '发送时间', field: 'sendTime',render:(data,full)=>{
                                  return DateUtil.formatDate(data,"yyyy-MM-dd hh:mm:ss");
                              }},
          ]
        }
      }
    }
  }
</script>
